import { BookmakerLandingIcon } from "../icons";
import Create from "./Create";
import Edit from "./Edit";
import List from "./List";

export default {
	options: {
		group: "bookmakers",
		roles: ["admin", "affiliate_manager"],
	},
	icon: BookmakerLandingIcon,
	list: List,
	edit: Edit,
	create: Create,
};
